"use strict";
exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/Observer.js
// module id = 125
// module chunks = 4